import { Identified } from "@/types/sdk-types";
import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { MedicalCodeControllerApi, MedicalCode } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../utils/utils";

interface UseFeeScheduleListProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  active?: boolean;
  archive?: boolean;
  source?: string;
  searchString?: string;
  xTENANTID?: string;
}

/**
 *
 * @author Rajkumar Rathod
 */
export function useFeeCptHcpcsCodeList({
  pagination,
  gridSorting,
  active,
  archive,
  source,
  searchString,
  xTENANTID,
}: UseFeeScheduleListProps): useBaseContent<Identified<MedicalCode>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "fee-schedule-code-cpt-hcpcs-list",
      pageSize,
      pageIndex,
      active,
      archive,
      source,
      searchString,
      xTENANTID,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new MedicalCodeControllerApi(getConfigObject())
        .getCptHcpcsMedicalCodes(
          pageIndex, //page
          pageSize, //size
          sortBy, // sortBy
          sortDirect, // sortDirection
          active,
          archive,
          source,
          searchString,
          xTENANTID
        )
        .then((res) => res?.data),
  });
}
